import * as S from '../styles';

import { RequestDemoForm } from './Form';
import { MessageSent } from './MessageSent';
import { useSubmit } from './useSubmit';

export const RequestDemo: React.FC = () => {
  const formHandler = useSubmit();

  return (
    <S.Container>
      {formHandler.sent ? (
        <MessageSent />
      ) : (
        <RequestDemoForm formHandler={formHandler} />
      )}
    </S.Container>
  );
};
